import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
export function ProductIntro() {
  return <Section className="bg-ink-950" innerClassName="max-w-6xl" data-id="element-205" data-mp="22mgcan4cy240">
      <div className="grid items-center gap-12 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-206" data-mp="1noe8cbtezem8">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/3ad1b560-60ff-4353-a221-b0893a57014e.jpg" alt="Portada del libro digital iPhone Experto" className="mx-auto w-full max-w-xs rounded-3xl border border-white/10 object-cover lg:max-w-sm" data-id="element-207" data-mp="1nqimdml11u08" />

        <div data-id="element-208" data-mp="2lalfnth3rl2a">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-209" data-mp="2lb4vn4n6zzdo">
            Presentamos la solución que estabas esperando
          </p>
          <h2 className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl" data-id="element-210" data-mp="2bl1u2g209d3q">
            iPhone Experto: Trucos, Ajustes y Secretos para Usar tu iPhone como
            un Profesional
          </h2>

          <div className="mt-6 space-y-4 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-211" data-mp="343pahi6243yh">
            <p data-id="element-212" data-mp="ug6r64yljqww">
              iPhone Experto es una guía práctica, completa y sencilla creada
              para que cualquier persona, sin importar su nivel técnico, aprenda
              a sacarle el máximo provecho a su iPhone.
            </p>
            <p className="text-white/80" data-id="element-213" data-mp="zf1kw1y3qzvs">
              Sin lenguaje complicado. Sin pasos confusos. Sin horas perdidas
              buscando tutoriales.
            </p>
            <p data-id="element-214" data-mp="1d89dnwxx61f2">
              Solo explicaciones claras, trucos útiles, configuraciones
              recomendadas y pasos simples que puedes aplicar hoy mismo para
              transformar la forma en que usas tu celular.
            </p>
            <p data-id="element-215" data-mp="1i4pz2jdqi1og">
              Esta guía está diseñada para que pases de usar tu iPhone «solo
              para lo básico» a dominarlo de verdad, con confianza, seguridad y
              control total.
            </p>
          </div>

          <div className="mt-10 flex justify-start" data-id="element-216" data-mp="3jy76pn1v72j7">
            <CTAButton data-id="element-217" data-mp="dfnlbtnjpeip" />
          </div>
        </div>
      </div>
    </Section>;
}